<template>
  <div class="article-container">
    <h1 class="rich_media_title " id="activity-name">
      {{ $t('newsinfo.mouthwash.title') }}
    </h1>
    <!-- 主图片 -->
    <div class="main-image">
      <img 
        src="https://www.healthcode.com/media/news/brownlin_files/640.jpg" 
        :alt="$t('newsinfo.mouthwash.altLogo')" 
        loading="lazy"
      />
    </div>
    
    <!-- 主要内容区 -->
    <div class="content-wrapper">
      <!-- 头部图片 -->
      <div class="header-image">
        <img 
          src="https://www.healthcode.com/media/news/brownlin_files/640(1).jpg" 
          :alt="$t('newsinfo.mouthwash.altChildOral')" 
          loading="lazy"
        />
      </div>
      
      <!-- 介绍段落 -->
      <div class="intro-section">
        <p>
          {{ $t('home.aboutus.headertext').split('，')[0] }}{{ $t('newsinfo.mouthwash.intro.commonIssues') }}，
          <strong>{{ $t('newsinfo.mouthwash.intro.report') }}</strong>{{ $t('newsinfo.mouthwash.intro.decayRate') }}，
          {{ $t('newsinfo.mouthwash.intro.peakAge') }}{{ $t('newsinfo.mouthwash.intro.commonIssues') }}，
          {{ $t('newsinfo.mouthwash.intro.riskFactors') }}
        </p>
      </div>
      
      <!-- 产品亮点图片 -->
      <div class="feature-image">
        <img 
          src="https://www.healthcode.com/media/news/brownlin_files/640(2).jpg" 
          :alt="$t('newsinfo.mouthwash.altFeatures')" 
          loading="lazy"
        />
      </div>
      
      <!-- 产品介绍 -->
      <div class="product-intro">
        <p>{{ $t('newsinfo.mouthwash.product.challenge') }}</p>
        <p>{{ $t('newsinfo.mouthwash.product.target') }}</p>
        <p class="main-title">{{ $t('newsinfo.mouthwash.product.name') }}</p>
        <p>{{ $t('newsinfo.mouthwash.product.formula') }}</p>
        <p>{{ $t('newsinfo.mouthwash.product.choice') }}</p>
        <p>{{ $t('newsinfo.mouthwash.product.start') }}</p>
        <p>{{ $t('newsinfo.mouthwash.product.habit') }}</p>
      </div>
      
      <!-- 系列图片展示 -->
      <div class="gallery-section">
        <div class="gallery-item" v-for="index in 4" :key="index">
          <img 
            :src="`https://www.healthcode.com/media/news/brownlin_files/640(${index + 2}).jpg`" 
            :alt="$t('newsinfo.mouthwash.altProductShow') + index" 
            loading="lazy"
          />
        </div>
      </div>
      
      <!-- 问题说明 -->
      <div class="problem-section">
        <p class="section-title">{{ $t('newsinfo.mouthwash.problem.title') }}</p>
        <p>{{ $t('newsinfo.mouthwash.problem.intake') }}</p>
      </div>
      
      <!-- 问题图片 -->
      <div class="problem-image">
        <img 
          src="https://www.healthcode.com/media/news/brownlin_files/640(7).jpg" 
          :alt="$t('newsinfo.mouthwash.altSugarIssue')" 
          loading="lazy"
        />
      </div>
      
      <!-- 解决方案 -->
      <div class="solution-section">
        <p>{{ $t('newsinfo.mouthwash.solution.issues') }}</p>
        <p>{{ $t('newsinfo.mouthwash.solution.increasing') }}</p>
        <p>{{ $t('newsinfo.mouthwash.solution.launch') }}</p>
        <p class="product-name">{{ $t('newsinfo.mouthwash.solution.name') }}</p>
        <p>{{ $t('newsinfo.mouthwash.solution.concept') }}</p>
        <p>{{ $t('newsinfo.mouthwash.solution.tech') }}</p>
        <p>{{ $t('newsinfo.mouthwash.solution.benefit') }}</p>
        <p>{{ $t('newsinfo.mouthwash.solution.goal') }}</p>
      </div>
      
      <!-- 更多展示图片 -->
      <div class="more-images">
        <div class="image-item" v-for="index in 2" :key="index">
          <img 
            :src="`https://www.healthcode.com/media/news/brownlin_files/640(${index + 7}).jpg`" 
            :alt="`${index + 7}${$t('newsinfo.mouthwash.altProductShow')}`" 
            loading="lazy"
          />
        </div>
      </div>
      
      <!-- 检测报告部分 -->
      <div class="report-section">
        <p>{{ $t('newsinfo.mouthwash.report.result') }}</p>
        <p class="report-title">{{ $t('newsinfo.mouthwash.report.title') }}</p>
        <p>{{ $t('newsinfo.mouthwash.report.result') }}</p>
      </div>
      
      <!-- 检测报告图片 -->
      <div class="report-image">
        <img 
          src="https://www.healthcode.com/media/news/brownlin_files/640(10).jpg" 
          :alt="$t('newsinfo.mouthwash.altReport')" 
          loading="lazy"
        />
      </div>
       <div class="report-image">
        <img 
          src="https://www.healthcode.com/media/news/brownlin_files/640(11).jpg" 
          :alt="$t('newsinfo.mouthwash.altReport')" 
          loading="lazy"
        />
      </div>
      
      <!-- 零添加保证 -->
      <div class="zero-section">
        <p class="section-title">{{ $t('newsinfo.mouthwash.zero.title') }}</p>
        <div class="zero-features">
          <p><span class="feature-tag">{{ $t('newsinfo.mouthwash.zero.features.title1') }}</span>{{ $t('newsinfo.mouthwash.zero.features.sugar') }}</p>
          <p><span class="feature-tag">{{ $t('newsinfo.mouthwash.zero.features.title2') }}</span>{{ $t('newsinfo.mouthwash.zero.features.alcohol') }}</p>
          <p><span class="feature-tag">{{ $t('newsinfo.mouthwash.zero.features.title3') }}</span>{{ $t('newsinfo.mouthwash.zero.features.fluoride') }}</p>
        </div>
        
        <div class="test-results">
          <p>{{ $t('newsinfo.mouthwash.report.title') }}</p>
          <p>{{ $t('newsinfo.mouthwash.zero.test.alcohol') }}</p>
          <p>{{ $t('newsinfo.mouthwash.zero.test.fluoride1') }}</p>
          <p>{{ $t('newsinfo.mouthwash.zero.test.fluoride2') }}</p>
          <p>{{ $t('newsinfo.mouthwash.zero.test.sugarContent') }}</p>
          <p class="highlight-text">{{ $t('newsinfo.mouthwash.zero.test.claim') }}</p>
        </div>
      </div>
      
      <!-- 产品特性三连图 -->
      <div class="triple-images">
        <div class="triple-item" v-for="index in 3" :key="index">
          <img 
            :src="`https://www.healthcode.com/media/news/brownlin_files/640(${index + 11}).jpg`" 
            :alt="$t('newsinfo.mouthwash.altCharac') + index" 
            loading="lazy"
          />
        </div>
      </div>
      
      <!-- 更多产品图片 -->
      <div class="product-gallery">
        <div class="gallery-item" v-for="index in 2" :key="index">
          <img 
            :src="`https://www.healthcode.com/media/news/brownlin_files/640(${index + 15}).jpg`" 
            :alt="$t('newsinfo.mouthwash.altProductShow') + (index + 15)" 
            loading="lazy"
          />
        </div>
      </div>
      
      <!-- 满意度报告 -->
      <div class="satisfaction-section">
        <p>{{ $t('newsinfo.mouthwash.satisfaction.title') }}</p>
        <p>
          {{ $t('newsinfo.mouthwash.satisfaction.criteria') }}
          {{ $t('newsinfo.mouthwash.satisfaction.rate') }}
        </p>
      </div>
      
    
      <div class="image-item" v-for="index in 2" :key="index">
          <img 
            :src="`https://www.healthcode.com/media/news/brownlin_files/640(${index + 17}).jpg`" 
            :alt="$t('newsinfo.mouthwash.altFinalShow') + index" 
            loading="lazy"
          />
        </div>
      <!-- 结语部分 -->
      <div class="conclusion-section"> 
        <p class="conclusion-text">{{ $t('newsinfo.mouthwash.conclusion.sweetTime') }}</p>
        <p class="conclusion-text">{{ $t('newsinfo.mouthwash.conclusion.startWith') }}</p>
        <p class="product-name" style="text-align: center;">{{ $t('newsinfo.mouthwash.conclusion.product') }}</p>
        <p class="conclusion-text">{{ $t('newsinfo.mouthwash.conclusion.protectTeeth') }}</p>
        <p class="conclusion-text">{{ $t('newsinfo.mouthwash.conclusion.protectMouth') }}</p>
        <p class="conclusion-text">{{ $t('newsinfo.mouthwash.conclusion.accompanySmile') }}</p>
      </div>
        <!-- 最终展示图片 -->
        <div class="final-images">
        <div class="image-item" v-for="index in 1" :key="index">
          <img 
            :src="`https://www.healthcode.com/media/news/brownlin_files/640(${index + 19}).jpg`" 
            :alt="$t('newsinfo.mouthwash.altFinalShow') + index" 
            loading="lazy"
          />
        </div>
      </div>
      
      <!-- 结尾图片 -->
      <div class="footer-image">
        <img 
          src="https://www.healthcode.com/media/news/brownlin_files/640(21).jpg" 
          :alt="$t('newsinfo.mouthwash.altEndShow')" 
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

onMounted(() => {
  console.log(t('newsinfo.mouthwash.title') + '页面加载完成')
  
  // 图片懒加载逻辑
  const images = document.querySelectorAll('img[loading="lazy"]')
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target
        img.src = img.dataset.src || img.src
        img.classList.add('loaded')
        imageObserver.unobserve(img)
      }
    })
  })
  
  images.forEach(img => imageObserver.observe(img))
})
</script>

<style scoped>
/* 保持原有样式不变 */
.article-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #3e3e3e;
  line-height: 1.6;
  max-width: 640px;
  margin: 0 auto;
  background-color: #f5fff7;
}
.rich_media_title {
  padding-top: 10px;
    font-size: 22px;
    line-height: 1.4;
    margin-bottom: 14px;
    font-weight: 700;
    margin-top: 100px;
}

.main-image,
.header-image,
.feature-image,
.problem-image,
.report-image,
.footer-image {
  text-align: center;
  margin: 0 0 20px;
}

.main-image img,
.header-image img,
.feature-image img,
.problem-image img,
.report-image img,
.footer-image img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

.content-wrapper {
  padding: 0 10px;
}

.intro-section,
.product-intro,
.problem-section,
.solution-section,
.report-section,
.zero-section,
.satisfaction-section,
.conclusion-section {
  margin-bottom: 30px;
}

.intro-section p,
.product-intro p,
.problem-section p,
.solution-section p,
.report-section p,
.zero-section p,
.satisfaction-section p,
.conclusion-section p {
  font-size: 16px;
  margin: 0 0 15px;
  text-align: justify;
  white-space: normal;
}

.highlight-text {
  color: #369b4d;
  font-weight: bold;
}

.main-title {
  font-size: 18px !important;
  color: #369b4d;
  font-weight: bold;
  margin: 20px 0 !important;
}

.section-title {
  font-size: 18px;
  color: #369b4d;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.product-name {
  font-size: 18px;
  color: #369b4d;
  font-weight: bold;
  text-align: center;
  margin: 20px 0 !important;
}

.report-title {
  font-size: 18px;
  color: #369b4d;
  font-weight: bold;
  margin: 20px 0 !important;
}

.gallery-section,
.more-images,
.product-gallery,
.final-images {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.gallery-item img,
.image-item img {
  width: 100%;
  height: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.zero-features {
  margin-bottom: 25px;
}

.feature-tag {
  color: #369b4d;
  font-weight: bold;
  font-size: 16px;
}

.test-results p {
  margin-bottom: 10px;
  font-size: 15px;
}

.triple-images {
  overflow-x: auto;
  gap: 10px;
  scrollbar-width: thin;
  scrollbar-color: #369b4d #f0f0f0;
}

.triple-images::-webkit-scrollbar {
  height: 6px;
}

.triple-images::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}

.triple-images::-webkit-scrollbar-thumb {
  background: #369b4d;
  border-radius: 3px;
}

.triple-item {
  flex: 0 0 calc(33.333% - 7px);
  min-width: calc(33.333% - 7px);
}

.triple-item img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.conclusion-text {
  text-align: center !important;
  font-size: 16px;
  margin: 10px 0 !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .article-container {
    padding: 0 8px;
  }
  
  .content-wrapper {
    padding: 0 8px;
  }
  
  .intro-section p,
  .product-intro p,
  .problem-section p,
  .solution-section p,
  .report-section p,
  .zero-section p,
  .satisfaction-section p,
  .conclusion-section p {
    font-size: 15px;
  }
  
  .main-title,
  .section-title,
  .product-name,
  .report-title {
    font-size: 17px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 0 5px;
  }
  
  .intro-section p,
  .product-intro p,
  .problem-section p,
  .solution-section p,
  .report-section p,
  .zero-section p,
  .satisfaction-section p,
  .conclusion-section p {
    font-size: 14px;
  }
  
  .main-title,
  .section-title,
  .product-name,
  .report-title {
    font-size: 16px;
  }
  
  .gallery-section,
  .more-images,
  .product-gallery,
  .final-images {
    gap: 15px;
  }
}

/* 动画效果 */
img {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

img.loaded {
  opacity: 1;
}

/* 打印优化 */
@media print {
  .article-container {
    background-color: white;
    color: black;
    max-width: 100%;
  }
  
  .highlight-text {
    color: #333;
  }
  
  .gallery-item img,
  .image-item img,
  .triple-item img {
    box-shadow: none;
    border: 1px solid #ddd;
  }
  
  .triple-images {
    overflow: visible;
    flex-wrap: wrap;
  }
  
  .triple-item {
    flex: 0 0 calc(33.333% - 10px);
    margin-bottom: 10px;
  }
}
</style>